import React, { useState } from 'react'
import { fetchEmailList, fetchPackagePermissions } from '../../../http'
import { postNotification } from '../../../data/actions'
import { connect } from 'react-redux'
import schema from '../../../assets/mocks/schema.json'

const EmailList = ({ packages, postNotification }) => {
  const [filter, setFilter] = useState({})
  const [roleFilter, setRoleFilter] = useState([])
  const [permissions, setPermissions] = useState({})
  const [providers, setProviders] = useState([])
  const [emailList, setEmailList] = useState()

  const roleEnums = schema.properties.members.items.properties.roles.items
  const { enum: roleEnum, enumNames } = roleEnums
  const roles = roleEnum.map((item, index) => [item, enumNames[index]])

  const groupPackagesByProviders = (packages) => {
    if (!packages) {
      return null
    }
    const groupedPackagesByProvider = {}
    packages.forEach((pkg) => {
      if (!groupedPackagesByProvider[pkg.providerSlug]) {
        groupedPackagesByProvider[pkg.providerSlug] = [pkg]
      } else {
        groupedPackagesByProvider[pkg.providerSlug].push(pkg)
      }
    })
    return groupedPackagesByProvider
  }

  const handleSubmit = async () => {
    event.preventDefault()
    const roleNames = roleFilter
    const permissionSlugs = []
    const packageSlugs = Object.keys(filter).map(
      (pkgIndex) => packages[pkgIndex].slug,
    )
    for (let pkgIndex in filter) {
      permissionSlugs.push(...filter[pkgIndex])
    }
    if (
      !providers.length &&
      !roleFilter.length &&
      !permissionSlugs.length &&
      !packageSlugs.length
    ) {
      postNotification({
        message:
          'Please choose role(s), provider(s), package(s) or permission(s)',
        mode: 'error',
      })
      return
    }
    const emails = await fetchEmailList({
      roleNames,
      permissionSlugs,
      providerSlugs: providers,
      packageSlugs,
    })
    setEmailList(emails.join(', '))
  }

  const setPackage = async (pkgIndex) => {
    const filterCopy = { ...filter }
    const newPackageIndices = Object.keys(filterCopy).map((item) =>
      parseInt(item),
    )
    const currentIndex = newPackageIndices.indexOf(pkgIndex)
    if (currentIndex > -1) {
      delete filterCopy[pkgIndex]
    } else {
      filterCopy[pkgIndex] = []
      if (!permissions[pkgIndex]) {
        const packagePermissions = await fetchPackagePermissions(
          packages[pkgIndex].slug,
        )
        setPermissions({
          ...permissions,
          [pkgIndex]: packagePermissions,
        })
      }
    }
    setFilter(filterCopy)
  }

  const setPermission = (packageIndex, permissionSlug) => {
    const filterCopy = { ...filter }
    if (filterCopy[packageIndex]) {
      const permissionsCopy = [...filterCopy[packageIndex]]
      if (permissionsCopy.includes(permissionSlug)) {
        filterCopy[packageIndex] = permissionsCopy.filter(
          (perm) => perm !== permissionSlug,
        )
      } else {
        permissionsCopy.push(permissionSlug)
        filterCopy[packageIndex] = permissionsCopy
      }
    } else {
      filterCopy[packageIndex] = [permissionSlug]
    }
    setFilter(filterCopy)
  }

  const setRole = (role) => {
    const roleFilterCopy = [...roleFilter]
    const roleIndex = roleFilterCopy.indexOf(role)
    if (roleIndex > -1) {
      roleFilterCopy.splice(roleIndex, 1)
    } else {
      roleFilterCopy.push(role)
    }
    setRoleFilter(roleFilterCopy)
  }

  const setProvider = (provider) => {
    const providersCopy = [...providers]
    const providerIndex = providersCopy.indexOf(provider)
    if (providerIndex > -1) {
      providersCopy.splice(providerIndex, 1)
    } else {
      providersCopy.push(provider)
    }
    setProviders(providersCopy)
  }

  const copyToClipboard = () => {
    const el = document.createElement('textarea')
    el.value = emailList
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

  const generatePackageCheckboxes = (packages) => {
    return packages?.map((pkg, index) => {
      const { name, slug } = pkg
      return (
        <React.Fragment key={`types_${slug}`}>
          <input
            type="checkbox"
            name={`${slug}_tenant_type`}
            id={`package_${slug}`}
            value={slug.toLowerCase()}
            onClick={() => setPackage(index)}
          />
          <label htmlFor={`package_${slug}`}>{name}</label>
          <br />
          {permissions[index] ? (
            generatePermissionCheckboxes(permissions[index], index)
          ) : (
            <span className="wb-margin-start-xs wb-type-hint"></span>
          )}
          <br />
        </React.Fragment>
      )
    })
  }

  const generateProviderCheckboxes = (groupedPackagesByProvider) => {
    const providers = Object.keys(groupedPackagesByProvider)
    return providers.map((provider) => (
      <React.Fragment key={`provider_${provider}`}>
        <input
          type="checkbox"
          name={`${provider}`}
          id={provider}
          value={provider.toLowerCase()}
          onClick={() => setProvider(provider)}
        />
        <label htmlFor={provider}>{provider}</label>
        <br />
      </React.Fragment>
    ))
  }

  const generateRoleCheckboxes = (roles) => {
    return roles.map(([key, label]) => {
      return (
        <React.Fragment key={`roles_${key}`}>
          <input
            type="checkbox"
            name={`tenant_role`}
            id={`role_${key}`}
            onClick={() => setRole(key)}
            value={key}
          />
          <label htmlFor={`role_${key}`}>{label}</label>
          <br />
        </React.Fragment>
      )
    })
  }

  const generatePermissionCheckboxes = (permissions, pkgIndex) => {
    return (
      <div>
        {permissions.length ? (
          <h3 className="wb-margin-start-xs">Permissions</h3>
        ) : null}
        {permissions.map((permission) => (
          <div key={permission.slug} className="wb-margin-start-xs">
            <input
              type="checkbox"
              id={`${permission.slug}`}
              value={permission.slug}
              onClick={() => setPermission(pkgIndex, permission.slug)}
            />
            <label htmlFor={`${permission.slug}`}>{permission.name}</label>
            <br />
          </div>
        ))}
      </div>
    )
  }

  const groupedPackagesByProvider = groupPackagesByProviders(packages)

  return (
    <div className="page-body__section">
      <h3 className="wb-type-heading-m page-body__margin-bottom-s">Exports</h3>

      <wb-accordion theme="light" prevent-mobile-flyout>
        <wb-accordion-item>
          <wb-accordion-toggle>Export emails from tenants</wb-accordion-toggle>
          <wb-accordion-section>
            <wb-accordion-mobile-header className="wb-type-heading-xs">
              Close
            </wb-accordion-mobile-header>
            <wb-accordion-content>
              <div className="tenant-body__table tenant-emails">
                <table
                  width="100%"
                  className="wb-table wb-table--striped wb-table--border-vertical wb-table--border-horizontal wb-type-copy-secondary"
                >
                  <tbody>
                    <tr>
                      <td
                        className="column column--dark column--header"
                        colSpan="10"
                      >
                        Export emails
                      </td>
                    </tr>
                    <tr>
                      <td className="column" width="20%">
                        <div className="tenant-emails__form">
                          <form onSubmit={() => handleSubmit()}>
                            <legend>Filter by Packages/Permissions</legend>
                            <div
                              style={{ maxHeight: '350px', overflowY: 'auto' }}
                            >
                              {generatePackageCheckboxes(packages)}
                            </div>
                            <br />
                            <br />
                            <legend>Filter by Providers</legend>

                            {generateProviderCheckboxes(
                              groupedPackagesByProvider,
                            )}
                            <br />
                            <legend>Filter by roles</legend>
                            {generateRoleCheckboxes(roles)}
                            <br />
                            <br />
                            <button
                              type="submit"
                              aria-label="Filter Members"
                              className="wb-button wb-button--primary wb-button--small"
                            >
                              <wb-icon
                                name="search"
                                aria-hidden="true"
                                class="wb-button__icon"
                              />
                              Filter
                            </button>
                          </form>
                        </div>
                      </td>
                      <td className="column" width="60%">
                        <legend>Emails to copy</legend>
                        <div className="tenant-emails__form__results">
                          {!emailList ? 'No results' : emailList}
                        </div>
                      </td>
                      <td className="column" width="20%">
                        <div className="">
                          {emailList && (
                            <React.Fragment>
                              <button
                                type="submit"
                                aria-label="Filter Members"
                                className="wb-button wb-button--secondary wb-button--small wb-margin-bottom-xs"
                                onClick={() =>
                                  window.open(`mailto: ${emailList}`)
                                }
                              >
                                <wb-icon
                                  name="contact"
                                  aria-hidden="true"
                                  class="wb-button__icon"
                                />
                                Open Email
                              </button>

                              <button
                                type="submit"
                                aria-label="Filter Members"
                                className="wb-button wb-button--secondary wb-button--small"
                                onClick={copyToClipboard}
                              >
                                Copy Emails
                              </button>
                            </React.Fragment>
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </wb-accordion-content>
          </wb-accordion-section>
        </wb-accordion-item>
      </wb-accordion>
    </div>
  )
}

export default connect(null, { postNotification })(EmailList)
